import React, { useMemo, useState } from "react";
import { useCheckout } from "../../providers/CheckoutProvider";
import UpsaleDialogCatalogue from "./UpsaleDialogCatalogue";
import UpsaleDialogDigitalFiles from "./UpsaleDialogDigitalFiles";

const DIALOGS = {
  CATALOGUE: UpsaleDialogCatalogue,
  DIGITAL_FILES: UpsaleDialogDigitalFiles,
};

const UpsaleWizard = () => {
  const { upsaleList } = useCheckout();
  const [currentStep, setCurrentStep] = useState(0);

  // Offers of a type this build does not know how to render are dropped up
  // front. Leaving them in the list would stall the wizard: the step never
  // advances past one, so every later offer stays hidden too.
  const offers = useMemo(
    () => (upsaleList ?? []).filter((offer) => DIALOGS[offer.type]),
    [upsaleList],
  );

  const handleNextStep = () => {
    setCurrentStep((currentStep) => currentStep + 1);
  };

  if (currentStep >= offers.length) {
    return null;
  }

  const offer = offers[currentStep];
  const Dialog = DIALOGS[offer.type];

  return <Dialog handleNextStep={handleNextStep} {...offer} />;
};

export default UpsaleWizard;
